import { render, staticRenderFns } from "./HighlightMatch.vue?vue&type=template&id=5e7b6510&"
import script from "./HighlightMatch.vue?vue&type=script&lang=js&"
export * from "./HighlightMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports